import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import CtaSection from '../components/home/CtaSection'
import ProcessSection from '../components/home/ProcessSections'
import ServicesSection from '../components/home/ServiceSection'
import HeroSection from '../components/home/HeroSection'
import { useLocation } from 'react-router-dom'

function HomePage() {
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location.hash]);
    return (
        <div>
            <Helmet>
                <title>Home - {utils.siteName}</title>
            </Helmet>
            <HeroSection />
            <ServicesSection />
            <ProcessSection />
            <CtaSection />
        </div>
    )
}

export default HomePage